import React from "react";
import ImageSrc from "../../assets/product.jpg";
import ReactImageFallback from "react-image-fallback";
import styled from "styled-components";

const Product = styled.div`
  width: 100%;
  height: 150px;
  margin-bottom: 10px;
  border: 1px solid #eee;
  border-radius: 5px;
  @media (max-width: 768px) {
    height: 110px;
  }
`;
const ImageContainer = styled.div`
  width: 25%;
  height: 100%;
  background: white;
  float: left;
  text-align: center;
  cursor: pointer;
  @media (max-width: 768px) {
    width: 30%;
  }
`;

const Image = styled.img`
  width: 95%;
  height: 95%;
  margin: 2%;
  border-radius: 5px;
`;

const DetailsContainer = styled.div`
  width: 73%;
  height: 100%;
  float: right;
  @media (max-width: 768px) {
    width: 65%;
  }
`;
const Details = styled.div`
  width: 80%;
  height: 100%;
  float: left;
  @media (max-width: 768px) {
    width: 70%;
  }
`;
const ProductName = styled.h2`
  font-size: 1.1em;
  margin: 0;
  padding: 4% 0 0 0;
  font-weight: 400;
`;
const Measurement = styled.p`
  font-size: 1em;
  margin: 0;
  padding: 2% 0 2.7% 0;
`;
const Price = styled.button`
  font-size: 1em;
  margin: 0;
  padding: 0;
  padding: 8px 20px;
  color: black;
  border: 1px solid #276fb7;
  border-radius: 5px;
  outline: none;
`;
const AddButton = styled.button`
  float: right;
  font-size: 20px;
  margin: 10% 10px 0 0;
  background: white;
  border: 1px solid #ccc;
  padding: 5px 12px;
  color: #ccc;
  cursor: pointer;
  outline: none;
  border-radius: 5px;
  &:hover {
    color: white;
    border: 1px solid #276fb7;
    background: #276fb7;
  }
`;
const product = (props) => {
  return (
    <Product>
      <ImageContainer
        onClick={() => props.showProductHandler(props.product._id, props.id)}
      >
        {/* <Image src={props.product.product.images[0]} alt="product name" /> */}
        <ReactImageFallback
          src={props.product.product.images[0]}
          fallbackImage="https://pixsector.com/cache/517d8be6/av5c8336583e291842624.png"
          initialImage="https://pixsector.com/cache/517d8be6/av5c8336583e291842624.png"
          alt="Product image"
          className="my-product-image"
        />
      </ImageContainer>
      <DetailsContainer>
        <Details
          onClick={() => props.showProductHandler(props.product._id, props.id)}
        >
          <ProductName>{props.product.name}</ProductName>
          <Measurement>{props.product.product.measurment}</Measurement>
          <Price>{props.product.price} tk</Price>
        </Details>
        <AddButton
          onClick={() => {
            props.addToCartHandler(props.id);
          }}
        >
          +
        </AddButton>
      </DetailsContainer>
    </Product>
  );
};

export default product;
